module.exports = __webpack_public_path__ + "static/img/down-corner-ramp-8m-x-4m_256.d3b77be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-corner-ramp-8m-x-4m_256.png
// module id = PXVX
// module chunks = 0